export class MembershipDetails {

    startDate: Date;
    membershipType: string;
    membershipPaymentType: string;

    guestMembership: GuestMembership;
    hostMembership: HostMembership[];

    constructor(props: { [key in keyof MembershipDetails]?: MembershipDetails[key] }) {
        Object.assign(this, {
            ...props
        });
    }
}

export class GuestMembership {
    startDate: Date;
    renewalDate: Date;
    membershipPaymentType: string;
    price: number;
    nextBilling: PaymentDetail;
    paymentCount: number;
    canCancel: boolean;
    membershipToMembershipPricingTierId: number;
    cancellationDate: Date;
    paymentDetails: PaymentDetail[];

    constructor(props: { [key in keyof GuestMembership]?: GuestMembership[key] }) {
        Object.assign(this, {
            ...props
        });
    }
}

export class HostMembership {
    //price: number;
    propertyCount: number;
    hostMembershipDetails: HostMembershipDetail[];

    constructor(props: { [key in keyof HostMembership]?: HostMembership[key] }) {
        Object.assign(this, {
            ...props
        });
    }
}

export class HostMembershipDetail {
    startDate: Date;
    renewalDate: Date;
    address: string;
    membershipPaymentType: string;
    price: number;
    nextBilling: PaymentDetail;
    paymentCount: number;
    canCancel: boolean;
    membershipToMembershipPricingTierId: number;
    cancellationDate: Date;
    paymentDetails: PaymentDetail[];

    constructor(props: { [key in keyof HostMembershipDetail]?: HostMembershipDetail[key] }) {
        Object.assign(this, {
            ...props
        });
    }
}

export class PaymentDetail {
    price: number;
    paymentDueDate: Date;

    constructor(props: { [key in keyof PaymentDetail]?: PaymentDetail[key] }) {
        Object.assign(this, {
            ...props
        });
    }
}

